import { ENTITY_TYPES } from 'common/constants';

const MEMBER_FIELDS = {
  [ENTITY_TYPES.SETUP_SCENARIO_SESSION]: 'sessions',
  [ENTITY_TYPES.CUSTOMER_EVENT]: 'customerEvents',
  [ENTITY_TYPES.EVENT_DATA_SET]: 'eventDataSets'
};

/**
 * Counts the selected entities that are members of a walk collection.
 *
 * A collection can reference the same member more than once, so each selected id is counted at
 * most once and the count never exceeds the selection.
 *
 * @param dataSet The walk collection, as served by the data set list.
 * @param entityType The ENTITY_TYPES value of the selected entities.
 * @param selectedIds The selected entity ids.
 *
 * @return The number of selected ids that are members of the collection.
 */
const countIncludedMembers = (dataSet, entityType, selectedIds) => {
  const memberField = MEMBER_FIELDS[entityType];
  const memberIds = new Set(
    ((memberField && dataSet[memberField]) || []).map(member => member.id)
  );

  return selectedIds.filter(selectedId => memberIds.has(selectedId)).length;
};

export default countIncludedMembers;
